<template>
  <div class="page-block products-img">
    <div class="wide">
      <div class="mid">
        <div class="grayscale">
          <div></div>
        </div>
        <div class="big_image">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'products-img',
  components: {
  },
  props: {
  }
}
</script>
